(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-countdown"] && !Shopify.designMode) return;
  try {
    
  class CollectionCountdownDays extends HTMLElement {
    connectedCallback() {
      this.value = this.querySelector('.days');
      if (!this.value) return;
      this.observer = new MutationObserver(() => this.toggle());
      this.observer.observe(this.value, { childList: true, characterData: true, subtree: true });
      this.toggle();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    toggle() {
      this.hidden = parseInt(this.value.textContent, 10) < 1;
    }
  }

  if (!customElements.get('collection-countdown-days')) {
    customElements.define('collection-countdown-days', CollectionCountdownDays);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  class CollectionGrid extends HTMLElement {
    connectedCallback() {
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      if (this.abortController) this.abortController.abort();
    }

    onChange(event) {
      const target = event.target;
      if (target.matches('[data-collection-grid-sort]')) {
        this.applySort(target.value);
      } else if (target.matches('.color-swatch__radio')) {
        this.onSwatchChange(target);
      }
    }

    onSubmit(event) {
      const select = event.target.querySelector('[data-collection-grid-sort]');
      if (!select) return;
      event.preventDefault();
      this.applySort(select.value);
    }

    applySort(value) {
      const url = new URL(window.location.href);
      if (value === this.dataset.defaultSort) {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', value);
      }
      url.searchParams.delete('page');
      this.load(url);
    }

    async load(url) {
      if (this.abortController) this.abortController.abort();
      const controller = new AbortController();
      this.abortController = controller;
      const requestUrl = new URL(url.toString());
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(requestUrl.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error('Section request failed');
        const markup = await response.text();
        const nextDocument = new DOMParser().parseFromString(markup, 'text/html');
        const nextList = nextDocument.querySelector('[data-collection-grid-list]');
        const list = this.querySelector('[data-collection-grid-list]');
        if (!nextList || !list) throw new Error('Section list missing');
        Array.from(nextList.children).forEach((item, index) => {
          item.style.setProperty('--collection-grid-delay', String(Math.min(index, 7)));
        });
        nextList.classList.add('collection-grid__list--entering');
        this.removeQuickBuyElements(list);
        list.replaceWith(nextList);
        const pagination = this.querySelector('[data-collection-grid-pagination]');
        const nextPagination = nextDocument.querySelector('[data-collection-grid-pagination]');
        if (pagination && nextPagination) pagination.replaceWith(nextPagination);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(url.toString());
        return;
      }
      if (this.abortController === controller) {
        this.abortController = null;
        this.removeAttribute('aria-busy');
      }
    }

    removeQuickBuyElements(list) {
      list.querySelectorAll('[data-quick-buy][aria-controls]').forEach((trigger) => {
        trigger.getAttribute('aria-controls').split(/\s+/).forEach((id) => {
          const element = id ? document.getElementById(id) : null;
          if (element && element.matches('quick-buy-drawer, quick-buy-popover')) element.remove();
        });
      });
    }

    onSwatchChange(radio) {
      const card = radio.closest('product-card');
      if (!card) return;
      const image = card.querySelector('.product-card__image');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (image && image.animate && !reduceMotion) {
        image.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 200, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      }
    }
  }

  if (!customElements.get('collection-grid')) {
    customElements.define('collection-grid', CollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-carousel"] && !Shopify.designMode) return;
  try {
    
  class ContentCarousel extends HTMLElement {
    connectedCallback() {
      this.onReady = this.onReady.bind(this);
      this.addEventListener('flickity:ready', this.onReady);
      this.querySelectorAll('flickity-carousel').forEach((carousel) => this.labelControls(carousel));
    }

    disconnectedCallback() {
      this.removeEventListener('flickity:ready', this.onReady);
    }

    onReady(event) {
      if (event.target.matches('flickity-carousel')) this.labelControls(event.target);
    }

    labelControls(carousel) {
      const { prevLabel, nextLabel, slideLabel } = this.dataset;
      carousel.querySelector(':scope > .flickity-prev-next-button.previous')?.setAttribute('aria-label', prevLabel);
      carousel.querySelector(':scope > .flickity-prev-next-button.next')?.setAttribute('aria-label', nextLabel);
      const dots = carousel.querySelectorAll(':scope > .flickity-page-dots > .dot');
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-label', slideLabel.replace('[index]', index + 1).replace('[total]', dots.length));
      });
    }
  }

  if (!customElements.get('content-carousel')) customElements.define('content-carousel', ContentCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqHashOpener extends HTMLElement {
    connectedCallback() {
      const hash = window.location.hash;
      if (!hash) return;

      let targetContent = null;
      try {
        targetContent = document.querySelector(hash);
      } catch (e) {
        return;
      }
      if (!targetContent) return;

      targetContent.scrollIntoView({ behavior: 'smooth' });

      const toggleButton = document.querySelector(`button[aria-controls="${hash.substring(1)}"]`);
      if (toggleButton && toggleButton.getAttribute('aria-expanded') === 'false') {
        toggleButton.click();
      }
    }
  }

  if (!customElements.get('faq-hash-opener')) {
    customElements.define('faq-hash-opener', FaqHashOpener);
  }

  const FAQ_CARDS_COLUMNS_QUERY = 'screen and (min-width: 1000px)';
  const FAQ_CARDS_CLIP_VISIBILITY = 0.35;

  class FaqCards extends HTMLElement {
    connectedCallback() {
      if (!this.sequence) {
        this.sequence = Array.from(this.children, (node) => {
          const children = node.hasAttribute('data-faq-card') ? null : Array.from(node.children);
          return { node, children };
        });
        this.isColumns = false;
      }
      this.cards = Array.from(this.querySelectorAll('[data-faq-card]'));
      this.clips = new Map(Array.from(this.querySelectorAll('[data-faq-clip]'), (clip) => [clip.dataset.faqClip, clip]));
      this.columnsQuery = window.matchMedia(FAQ_CARDS_COLUMNS_QUERY);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onClick = this.onClick.bind(this);
      this.onClipState = this.onClipState.bind(this);
      this.onColumnsChange = this.layout.bind(this);
      this.addEventListener('click', this.onClick);
      this.columnsQuery.addEventListener('change', this.onColumnsChange);
      this.layout();
      this.watchClips();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.columnsQuery?.removeEventListener('change', this.onColumnsChange);
      this.clipVideos?.forEach((video) => {
        video.removeEventListener('play', this.onClipState);
        video.removeEventListener('pause', this.onClipState);
      });
      this.clipObserver?.disconnect();
    }

    onClick(event) {
      const clipToggle = event.target.closest('[data-faq-clip-toggle]');
      if (clipToggle && this.contains(clipToggle)) {
        this.toggleClip(clipToggle.closest('[data-faq-clip]').querySelector('video'));
        return;
      }

      const question = event.target.closest('.faq-card__question');
      if (!question || !this.contains(question)) return;

      const card = question.closest('.faq-card');
      const open = !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      question.setAttribute('aria-expanded', String(open));
      card.querySelector('.faq-card__answer').inert = !open;
    }

    layout() {
      const useColumns = this.columnsQuery.matches;
      if (useColumns === this.isColumns) return;
      this.isColumns = useColumns;
      this.classList.toggle('faq-cards--columns', useColumns);
      if (useColumns) this.buildColumns();
      else this.restoreSequence();
    }

    buildColumns() {
      const columns = [document.createElement('div'), document.createElement('div')];
      columns.forEach((column) => (column.className = 'faq-cards__column'));
      this.cards.forEach((card) => {
        const column = columns[card.dataset.desktopColumn === '1' ? 0 : 1];
        const clip = this.clips.get(card.dataset.desktopClip);
        if (!clip) {
          column.append(card);
          return;
        }
        const group = document.createElement('div');
        if (card.dataset.desktopLayout === 'over') {
          group.className = 'faq-cards__over';
          group.append(card, clip);
        } else {
          group.className = 'faq-cards__duo';
          group.append(clip, card);
        }
        column.append(group);
      });
      this.replaceChildren(...columns);
    }

    restoreSequence() {
      this.sequence.forEach(({ node, children }) => {
        if (children) node.replaceChildren(...children);
      });
      this.replaceChildren(...this.sequence.map(({ node }) => node));
    }

    watchClips() {
      const videos = Array.from(this.clips.values(), (clip) => clip.querySelector('video')).filter(Boolean);
      this.clipVideos = videos;
      videos.forEach((video) => {
        video.addEventListener('play', this.onClipState);
        video.addEventListener('pause', this.onClipState);
      });
      if (!videos.length || !('IntersectionObserver' in window)) return;

      this.clipObserver = new IntersectionObserver(
        (entries) => entries.forEach(({ target, isIntersecting }) => this.onClipVisibility(target, isIntersecting)),
        { threshold: FAQ_CARDS_CLIP_VISIBILITY }
      );
      videos.forEach((video) => this.clipObserver.observe(video));
    }

    onClipVisibility(video, visible) {
      video.isOnScreen = visible;
      if (!visible) {
        video.pause();
        return;
      }
      if (video.userPaused || this.reducedMotion.matches || document.hidden) return;
      this.playClip(video);
    }

    toggleClip(video) {
      if (!video) return;
      if (video.paused) {
        video.userPaused = false;
        this.playClip(video, true);
      } else {
        video.userPaused = true;
        video.pause();
      }
    }

    async playClip(video, requested = false) {
      if (!video.getAttribute('src')) {
        const original = video.querySelector('source[type="video/mp4"]')?.src || video.currentSrc;
        const preview = window.ThemeVideo ? await window.ThemeVideo.previewSource(original) : original;
        if (preview && !video.getAttribute('src')) video.src = preview;
      }
      if (video.isConnected && (requested || (video.isOnScreen && !video.userPaused))) video.play().catch(() => {});
    }

    onClipState(event) {
      const clip = event.currentTarget.closest('[data-faq-clip]');
      const toggle = clip?.querySelector('[data-faq-clip-toggle]');
      if (!toggle) return;
      const playing = !event.currentTarget.paused;
      clip.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
    }
  }

  if (!customElements.get('faq-cards')) {
    customElements.define('faq-cards', FaqCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-feature-list-expand]');
    if (!button) return;
    button.closest('.feature-list').classList.add('is-expanded');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const OPEN_DELAY = 90;
    const CLOSE_DELAY = 180;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const loadHeaderSearch = (root, host) => {
      const indexElement = document.querySelector('[data-search-index]');
      const moduleUrl = document.querySelector('header-nav[search-module]')?.getAttribute('search-module');
      if (!root || !indexElement || !moduleUrl) return Promise.resolve(null);
      return import(moduleUrl)
        .then(({ SearchIndex, HeaderSearchUi }) => {
          if (!window.headerSearchIndex) window.headerSearchIndex = new SearchIndex(JSON.parse(indexElement.textContent));
          return new HeaderSearchUi(root, window.headerSearchIndex, { host });
        })
        .catch(() => null);
    };

    class HeaderNav extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-panel]');
        this.searchPanel = this.querySelector('[data-search-panel]');
        this.searchToggle = this.querySelector('[data-search-open]');
        this.navButtons = Array.from(this.querySelectorAll('[data-panel-open]'));
        this.current = '';
        this.openTimer = 0;
        this.closeTimer = 0;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        this.navButtons.forEach((button) => {
          button.addEventListener('mouseenter', () => {
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => this.openPanel(button.dataset.panelOpen), this.isPanelOpen ? 0 : OPEN_DELAY);
          }, options);
          button.addEventListener('mouseleave', () => clearTimeout(this.openTimer), options);
          button.addEventListener('pointerdown', (event) => {
            this.pressPointerType = event.pointerType;
          }, options);
          button.addEventListener('click', (event) => {
            const pressedWithMouse = event.detail > 0 && this.pressPointerType === 'mouse';
            this.pressPointerType = '';
            if (this.isPanelOpen && this.current === button.dataset.panelOpen && !pressedWithMouse) {
              this.closeAll();
            } else {
              this.openPanel(button.dataset.panelOpen);
            }
          }, options);
        });

        this.addEventListener('mouseenter', () => clearTimeout(this.closeTimer), options);
        this.addEventListener('mouseleave', () => {
          clearTimeout(this.openTimer);
          if (!this.isSearchOpen) this.closeTimer = setTimeout(() => this.closeAll(), CLOSE_DELAY);
        }, options);

        if (this.panel) {
          this.panel.addEventListener('mouseover', (event) => this.activate(event.target), options);
          this.panel.addEventListener('focusin', (event) => this.activate(event.target), options);
        }

        if (this.searchToggle) {
          this.searchToggle.addEventListener('pointerenter', () => this.loadSearch(), options);
          this.searchToggle.addEventListener('focus', () => this.loadSearch(), options);
          this.searchToggle.addEventListener('click', () => {
            const willOpen = !this.isSearchOpen;
            this.closeAll();
            if (willOpen) this.openSearch();
          }, options);
        }

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || (!this.isPanelOpen && !this.isSearchOpen)) return;
          const returnTo = this.isSearchOpen ? this.searchToggle : this.navButtons.find((button) => button.dataset.panelOpen === this.current);
          this.closeAll();
          if (returnTo) returnTo.focus();
        }, options);

        document.addEventListener('click', (event) => {
          if ((this.isPanelOpen || this.isSearchOpen) && !event.composedPath().includes(this)) this.closeAll();
        }, options);

        this.addEventListener('keydown', (event) => this.onPanelTab(event), options);
        this.addEventListener('focusout', (event) => {
          if (!event.relatedTarget || this.contains(event.relatedTarget)) return;
          if (this.isPanelOpen || this.isSearchOpen) this.closeAll();
        }, options);
      }

      disconnectedCallback() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.abort.abort();
      }

      onPanelTab(event) {
        if (event.key !== 'Tab' || !this.isPanelOpen) return;
        const button = this.navButtons.find((item) => item.dataset.panelOpen === this.current);
        const panelItems = this.focusablesIn(this.panel);
        if (!button || !panelItems.length) return;
        let next = null;
        if (event.target === button && !event.shiftKey) {
          next = panelItems[0];
        } else if (event.target === panelItems[0] && event.shiftKey) {
          next = button;
        } else if (event.target === panelItems[panelItems.length - 1] && !event.shiftKey) {
          const rowItems = this.focusablesIn(this.querySelector('.header__row'));
          next = rowItems[rowItems.indexOf(button) + 1] || null;
          this.closeAll();
        }
        if (!next) return;
        event.preventDefault();
        next.focus();
      }

      focusablesIn(container) {
        if (!container) return [];
        return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((item) => item.getClientRects().length > 0);
      }

      get isPanelOpen() {
        return Boolean(this.panel && this.panel.classList.contains('is-open'));
      }

      get isSearchOpen() {
        return Boolean(this.searchPanel && this.searchPanel.classList.contains('is-open'));
      }

      show(element, open) {
        if (!element) return;
        element.classList.toggle('is-open', open);
        element.inert = !open;
      }

      markButtons() {
        this.navButtons.forEach((button) => button.setAttribute('aria-expanded', String(this.isPanelOpen && button.dataset.panelOpen === this.current)));
        if (this.searchToggle) this.searchToggle.setAttribute('aria-expanded', String(this.isSearchOpen));
      }

      openPanel(key) {
        clearTimeout(this.closeTimer);
        clearTimeout(this.openTimer);
        if (!this.panel) return;
        const wasOpen = this.isPanelOpen || this.isSearchOpen;
        this.show(this.searchPanel, false);
        if (this.current !== key) {
          this.current = key;
          this.panel.dataset.active = key;
          this.panel.querySelectorAll('[data-panel-area]').forEach((area) => {
            area.hidden = area.dataset.panelArea !== key;
          });
        }
        this.show(this.panel, true);
        this.markButtons();
        if (!wasOpen) this.dispatchEvent(new CustomEvent('desktop-nav:dropdown:open', { bubbles: true }));
      }

      openSearch() {
        if (!this.searchPanel) return;
        this.show(this.panel, false);
        this.show(this.searchPanel, true);
        this.markButtons();
        this.dispatchEvent(new CustomEvent('desktop-nav:dropdown:open', { bubbles: true }));
        this.loadSearch().then((ui) => {
          if (!ui) return;
          ui.render();
          setTimeout(() => ui.input.focus({ preventScroll: true }), 60);
        });
      }

      closeAll() {
        clearTimeout(this.openTimer);
        const wasOpen = this.isPanelOpen || this.isSearchOpen;
        this.show(this.panel, false);
        this.show(this.searchPanel, false);
        this.markButtons();
        if (wasOpen) this.dispatchEvent(new CustomEvent('desktop-nav:dropdown:close', { bubbles: true }));
      }

      activate(target) {
        const row = target.closest('[data-panel-row]');
        if (row) {
          const area = row.closest('[data-panel-area]');
          area.querySelectorAll('[data-panel-row]').forEach((item) => item.classList.toggle('is-active', item === row));
          area.querySelectorAll('[data-panel-preview]').forEach((preview) => {
            preview.hidden = preview.dataset.panelPreview !== row.dataset.panelRow;
          });
          return;
        }
        const item = target.closest('[data-collection-item]');
        if (!item) return;
        const stage = item.closest('[data-collections]');
        const key = item.dataset.collectionItem;
        if (stage.dataset.active === key) return;
        stage.dataset.active = key;
        stage.querySelectorAll('[data-collection-key]').forEach((element) => element.classList.toggle('is-active', element.dataset.collectionKey === key));
      }

      loadSearch() {
        if (!this.searchPromise) this.searchPromise = loadHeaderSearch(this.searchPanel && this.searchPanel.querySelector('[data-header-search]'), this);
        return this.searchPromise;
      }
    }

    if (!customElements.get('header-nav')) customElements.define('header-nav', HeaderNav);

    const DrawerContent = customElements.get('drawer-content');
    if (!DrawerContent || customElements.get('header-menu')) return;

    class HeaderMenu extends DrawerContent {
      connectedCallback() {
        super.connectedCallback();
        this.defaultArea = this.dataset.activeArea;
        this.scroller = this.querySelector('[data-menu-scroll]');
        this.searchRoot = this.querySelector('[data-header-search]');
        this.cancelButton = this.querySelector('[data-search-cancel]');
        this.tabs = Array.from(this.querySelectorAll('[data-menu-tab]'));
        this.delegate.on('click', '[data-menu-tab]', (event, tab) => this.setArea(tab.dataset.menuTab, true));
        this.delegate.on('keydown', '[data-menu-tab]', (event, tab) => this.onTabKey(event, tab));
        this.delegate.on('click', '[data-search-cancel]', () => this.leaveSearch());
        this.delegate.on('focusin', '[data-search-input]', () => this.setSearching(true));
        this.delegate.on('pointerdown', '[data-search-box]', () => this.loadSearch());
        this.delegate.on('click', '[data-search-box]', (event) => {
          if (event.target.closest('button')) return;
          this.setSearching(true);
          const input = this.querySelector('[data-search-input]');
          if (input) input.focus();
        });
        this.addEventListener('header-search:query', (event) => {
          if (event.detail.query) this.setSearching(true);
          if (this.scroller) this.scroller.scrollTop = 0;
        });
        this.onEscape = (event) => {
          if (event.key !== 'Escape' || !this.open || !this.hasAttribute('data-searching')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.leaveSearch();
        };
        window.addEventListener('keydown', this.onEscape, true);
        this.applyArea(this.dataset.activeArea);
      }

      disconnectedCallback() {
        window.removeEventListener('keydown', this.onEscape, true);
        clearTimeout(this.closingTimer);
        this.unpinPage();
        this.unwatchKeyboard();
        if (super.disconnectedCallback) super.disconnectedCallback();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name !== 'open') return;
        clearTimeout(this.closingTimer);
        if (oldValue === null && newValue === '') {
          this.removeAttribute('data-closing');
          this.removeAttribute('data-switched');
          this.setSearching(false);
          this.applyArea(this.pendingArea || this.defaultArea);
          this.pendingArea = '';
          if (this.scroller) this.scroller.scrollTop = 0;
          this.pinPage();
          this.watchKeyboard();
          document.documentElement.dispatchEvent(new CustomEvent('mobile-nav:open', { bubbles: true }));
        } else if (newValue === null) {
          this.unwatchKeyboard();
          this.unpinPage();
          this.setAttribute('data-closing', '');
          this.closingTimer = setTimeout(() => this.removeAttribute('data-closing'), reducedMotion() ? 220 : 320);
          document.documentElement.dispatchEvent(new CustomEvent('mobile-nav:close', { bubbles: true }));
        }
      }

      loadSearch() {
        if (!this.searchPromise) this.searchPromise = loadHeaderSearch(this.searchRoot, this);
        return this.searchPromise;
      }

      pinPage() {
        if (this.pinnedScroll != null) return;
        const root = document.documentElement;
        this.pinnedScroll = window.scrollY;
        root.style.setProperty('--header-menu-pinned-top', `${-this.pinnedScroll}px`);
        root.classList.add('header-menu-pinned');
      }

      unpinPage() {
        if (this.pinnedScroll == null) return;
        const root = document.documentElement;
        const top = this.pinnedScroll;
        this.pinnedScroll = null;
        root.classList.add('header-menu-restoring');
        root.classList.remove('header-menu-pinned');
        root.style.removeProperty('--header-menu-pinned-top');
        window.scrollTo(0, top);
        root.classList.remove('header-menu-restoring');
      }

      watchKeyboard() {
        const viewport = window.visualViewport;
        if (!viewport || this.onViewportChange) return;
        this.keyboardInset = 0;
        this.onViewportChange = () => {
          const inset = Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop));
          if (inset === this.keyboardInset) return;
          this.keyboardInset = inset;
          this.style.setProperty('--header-menu-keyboard', `${inset}px`);
        };
        viewport.addEventListener('resize', this.onViewportChange);
        viewport.addEventListener('scroll', this.onViewportChange, { passive: true });
        this.onViewportChange();
      }

      unwatchKeyboard() {
        const viewport = window.visualViewport;
        if (!viewport || !this.onViewportChange) return;
        viewport.removeEventListener('resize', this.onViewportChange);
        viewport.removeEventListener('scroll', this.onViewportChange);
        this.onViewportChange = null;
        this.style.removeProperty('--header-menu-keyboard');
      }

      openArea(key) {
        if (this.open) {
          this.setArea(key);
          return;
        }
        this.pendingArea = key;
        this.open = true;
      }

      leaveSearch() {
        this.setSearching(false);
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) dialog.focus({ preventScroll: true });
      }

      setSearching(on) {
        if (on === this.hasAttribute('data-searching')) return;
        this.toggleAttribute('data-searching', on);
        if (this.cancelButton) this.cancelButton.hidden = !on;
        if (this.scroller) this.scroller.scrollTop = 0;
        this.loadSearch().then((ui) => {
          if (!ui) return;
          if (!on) {
            ui.input.value = '';
            ui.input.blur();
          }
          ui.render();
        });
      }

      applyArea(key) {
        const tab = this.tabs.find((item) => item.dataset.menuTab === key) || this.tabs[0];
        if (!tab) return;
        this.dataset.activeArea = tab.dataset.menuTab;
        this.dataset.areaStyle = tab.dataset.areaStyle || 'standard';
        this.dataset.firstArea = String(this.tabs.indexOf(tab) === 0);
        const accent = tab.style.getPropertyValue('--header-accent');
        if (accent) {
          this.style.setProperty('--header-accent', accent);
        } else {
          this.style.removeProperty('--header-accent');
        }
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[data-menu-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.menuPanel !== tab.dataset.menuTab;
        });
      }

      setArea(key, animate) {
        if (key === this.dataset.activeArea) return;
        const wasPlayful = this.dataset.areaStyle === 'playful';
        this.applyArea(key);
        if (!animate) return;
        this.removeAttribute('data-switched');
        void this.offsetWidth;
        this.setAttribute('data-switched', '');
        if (this.dataset.areaStyle === 'playful' && !wasPlayful) this.burst();
      }

      onTabKey(event, tab) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        const next = this.tabs[(index + (event.key === 'ArrowRight' ? 1 : this.tabs.length - 1)) % this.tabs.length];
        this.setArea(next.dataset.menuTab, true);
        next.focus();
      }

      burst() {
        if (reducedMotion()) return;
        const tab = this.tabs.find((item) => item.dataset.menuTab === this.dataset.activeArea);
        const sheet = this.querySelector('.header-menu__sheet');
        if (!tab || !sheet || !sheet.animate) return;
        const sheetBox = sheet.getBoundingClientRect();
        const tabBox = tab.getBoundingClientRect();
        const originX = tabBox.left - sheetBox.left + tabBox.width / 2;
        const originY = tabBox.top - sheetBox.top + tabBox.height / 2;
        for (let index = 0; index < 18; index += 1) {
          const bit = document.createElement('i');
          bit.className = 'header-menu__bit header-menu__bit--color-' + (index % 6) + (index % 3 === 0 ? ' header-menu__bit--star' : index % 3 === 1 ? ' header-menu__bit--strip' : '');
          bit.style.cssText = `left:${originX}px;top:${originY}px`;
          sheet.appendChild(bit);
          const angle = (index / 18) * Math.PI * 2 + Math.random() * 0.35;
          const distance = 46 + Math.random() * 64;
          const rotation = Math.round(Math.random() * 300 - 150);
          const dx = Math.cos(angle) * distance;
          const dy = Math.sin(angle) * distance * 0.8;
          bit.animate([
            { transform: 'translate(-50%,-50%) scale(.5)', opacity: 1 },
            { transform: `translate(calc(-50% + ${dx}px),calc(-50% + ${dy}px)) scale(1) rotate(${rotation * 0.7}deg)`, opacity: 1, offset: 0.62 },
            { transform: `translate(calc(-50% + ${dx * 1.12}px),calc(-50% + ${dy * 1.12 + 22}px)) scale(.7) rotate(${rotation}deg)`, opacity: 0 }
          ], { duration: 720 + Math.random() * 260, easing: 'cubic-bezier(.23,1,.32,1)' }).onfinish = () => bit.remove();
        }
      }
    }

    customElements.define('header-menu', HeaderMenu);

    if (!window.Shopify || !window.Shopify.designMode) return;

    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const nav = target.closest('header-nav');
      if (nav) {
        const areaKey = target.dataset.panelOpen || '';
        const collection = target.closest('[data-collections]');
        const firstArea = nav.navButtons[0] ? nav.navButtons[0].dataset.panelOpen : '';
        nav.openPanel(collection ? 'collections' : areaKey.startsWith('area-') ? areaKey : firstArea);
        if (collection) nav.activate(target.querySelector('[data-collection-item]') || target);
        return;
      }
      const menu = target.closest('header-menu');
      if (!menu) return;
      const tabKey = target.dataset.menuTab || '';
      const extra = target.closest('[data-menu-collections], [data-trustpilot]');
      const firstTab = menu.tabs[0] ? menu.tabs[0].dataset.menuTab : menu.defaultArea;
      menu.openArea(tabKey ? tabKey : extra ? firstTab : menu.defaultArea);
      if (extra) setTimeout(() => target.scrollIntoView({ block: 'center' }), 460);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || !target.closest('header-nav, header-menu')) return;
      const nav = document.querySelector('header-nav');
      const menu = document.querySelector('header-menu');
      if (nav) nav.closeAll();
      if (menu) menu.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-tabs"] && !Shopify.designMode) return;
  try {
    
  class MediaTabsPlayer extends HTMLElement {
    connectedCallback() {
      this.switcher = this.querySelector('media-content-tabs');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.segments = Array.from(this.querySelectorAll('[data-media-tabs-segment]'));
      this.pauseReasons = new Set();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.stopAutoplay = this.stopAutoplay.bind(this);
      this.onAnimationEnd = this.onAnimationEnd.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.onMouseEnter = () => this.pause('hover');
      this.onMouseLeave = () => this.resume('hover');
      this.onFocusIn = () => this.pause('focus');
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.resume('focus');
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('shopify:block:select', this.stopAutoplay);

      this.observer = new MutationObserver(() => this.syncProgress());
      this.observer.observe(this, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
      this.syncProgress();

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('shopify:block:select', this.stopAutoplay);
      this.observer?.disconnect();
      this.teardownAutoplay();
    }

    get activeIndex() {
      return Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
    }

    select(index) {
      if (typeof this.switcher?.select === 'function') this.switcher.select(index);
    }

    syncProgress() {
      const current = this.activeIndex;
      this.segments.forEach((segment, index) => segment.classList.toggle('is-active', index === current));
    }

    onClick(event) {
      if (event.isTrusted && event.target.closest('[role="tab"]')) this.stopAutoplay();
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) this.stopAutoplay();
      if (event.key !== 'Home' && event.key !== 'End') return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : this.tabs.length - 1;
      this.select(target);
      this.tabs[target].focus();
    }

    startAutoplay() {
      const duration = Number(this.dataset.autoplay) || 0;
      if (!duration || this.tabs.length < 2 || this.reducedMotion.matches) return;

      this.style.setProperty('--media-tabs-duration', `${duration}ms`);
      this.classList.add('is-autoplaying');
      this.autoplayActive = true;

      this.addEventListener('animationend', this.onAnimationEnd);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.reducedMotion.addEventListener?.('change', this.onMotionChange);

      if ('IntersectionObserver' in window) {
        this.pause('offscreen');
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => (entry.isIntersecting ? this.resume('offscreen') : this.pause('offscreen')));
          },
          { threshold: 0.35 }
        );
        this.intersectionObserver.observe(this);
      }
    }

    stopAutoplay() {
      if (!this.autoplayActive) return;
      this.classList.remove('is-autoplaying', 'is-paused');
      this.teardownAutoplay();
    }

    teardownAutoplay() {
      this.autoplayActive = false;
      this.removeEventListener('animationend', this.onAnimationEnd);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.reducedMotion?.removeEventListener?.('change', this.onMotionChange);
      this.intersectionObserver?.disconnect();
      this.intersectionObserver = null;
    }

    onAnimationEnd(event) {
      if (event.animationName !== 'media-tabs-progress' || !this.autoplayActive) return;
      this.select((this.activeIndex + 1) % this.tabs.length);
    }

    onVisibilityChange() {
      if (document.hidden) this.pause('hidden');
      else this.resume('hidden');
    }

    onMotionChange(event) {
      if (event.matches) this.stopAutoplay();
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.classList.toggle('is-paused', this.pauseReasons.size > 0);
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.classList.toggle('is-paused', this.pauseReasons.size > 0);
    }
  }

  if (!customElements.get('media-tabs-player')) customElements.define('media-tabs-player', MediaTabsPlayer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-wall"] && !Shopify.designMode) return;
  try {
    
  const MEDIA_WALL_COLUMNS_QUERY = 'screen and (min-width: 1000px)';
  const MEDIA_WALL_COLUMN_DURATIONS = [46, 58, 52, 64];
  const MEDIA_WALL_MIN_TILES_PER_COLUMN = 3;
  const MEDIA_WALL_PREVIEW_SECONDS = 3;
  const MEDIA_WALL_PREVIEW_HEIGHT = 480;
  const MEDIA_WALL_TILE_VISIBILITY = 0.25;
  const MEDIA_WALL_TILE_THRESHOLDS = [0, 0.25, 0.5, 0.75, 1];
  const MEDIA_WALL_RUN_VISIBILITY = 0.05;
  const MEDIA_WALL_PREPARE_MARGIN = '600px 0px';

  class MediaWall extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.media-wall__track');
      this.player = this.querySelector('.media-wall__player');
      this.playerVideo = this.querySelector('.media-wall__player-video');
      this.playerCreator = this.querySelector('[data-wall-player-creator]');
      this.toggleButton = this.querySelector('.media-wall__toggle');
      this.closeButton = this.querySelector('.media-wall__close');
      this.pauseButton = this.querySelector('[data-wall-pause]');
      this.counter = this.querySelector('[data-wall-counter]');
      this.prevStep = this.querySelector('[data-wall-step="-1"]');
      this.nextStep = this.querySelector('[data-wall-step="1"]');
      if (!this.track || !this.player || !this.playerVideo || !this.toggleButton || !this.closeButton) return;

      this.isActive = true;
      this.isPaused = false;
      this.tiles = Array.from(this.track.children);
      this.clips = this.tiles.filter((tile) => tile.dataset.wallClip);
      this.clips.forEach((tile, index) => {
        tile.dataset.wallIndex = String(index);
      });
      this.clipIndex = 0;
      this.columnsQuery = window.matchMedia(MEDIA_WALL_COLUMNS_QUERY);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onTileClick = this.onTileClick.bind(this);
      this.onPlayerClick = this.onPlayerClick.bind(this);
      this.onPauseClick = this.onPauseClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPlayState = this.onPlayState.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.close = this.close.bind(this);
      this.build = this.build.bind(this);

      this.track.addEventListener('click', this.onTileClick);
      this.player.addEventListener('click', this.onPlayerClick);
      this.pauseButton?.addEventListener('click', this.onPauseClick);
      this.playerVideo.addEventListener('ended', this.close);
      this.playerVideo.addEventListener('play', this.onPlayState);
      this.playerVideo.addEventListener('pause', this.onPlayState);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.columnsQuery.addEventListener('change', this.build);

      this.previewObserver = new IntersectionObserver((entries) => this.onPreviewVisibility(entries), {
        threshold: MEDIA_WALL_TILE_THRESHOLDS,
      });
      this.runObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => this.classList.toggle('is-running', entry.isIntersecting)),
        { threshold: MEDIA_WALL_RUN_VISIBILITY }
      );
      this.prepareObserver = new IntersectionObserver((entries) => this.onApproach(entries), {
        rootMargin: MEDIA_WALL_PREPARE_MARGIN,
      });
      this.playerObserver = new IntersectionObserver((entries) => entries.forEach((entry) => this.onPlayerVisibility(entry)));
      this.runObserver.observe(this.track);
      this.prepareObserver.observe(this.track);
      this.playerObserver.observe(this.player.firstElementChild);
      this.build();
    }

    disconnectedCallback() {
      this.isActive = false;
      this.previewGeneration = (this.previewGeneration || 0) + 1;
      this.track?.removeEventListener('click', this.onTileClick);
      this.player?.removeEventListener('click', this.onPlayerClick);
      this.pauseButton?.removeEventListener('click', this.onPauseClick);
      this.playerVideo?.removeEventListener('ended', this.close);
      this.playerVideo?.removeEventListener('play', this.onPlayState);
      this.playerVideo?.removeEventListener('pause', this.onPlayState);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.columnsQuery?.removeEventListener('change', this.build);
      this.previewObserver?.disconnect();
      this.runObserver?.disconnect();
      this.prepareObserver?.disconnect();
      this.playerObserver?.disconnect();
      this.track?.querySelectorAll('video').forEach((video) => video.pause());
      if (this.playerVideo) {
        this.playerVideo.pause();
        this.playerVideo.removeAttribute('src');
        this.playerVideo.load();
      }
      if (this.player) this.player.hidden = true;
      this.setPaused(false);
      this.classList.remove('is-held');
      this.classList.remove('is-running');
      this.lastTile = null;
      this.playerSeen = false;
      if (this.track && this.tiles) this.track.replaceChildren(...this.tiles);
    }

    build() {
      this.previewGeneration = (this.previewGeneration || 0) + 1;
      if (!this.tiles.length) return;
      this.previewObserver.disconnect();

      const columnCount = this.columnsQuery.matches ? 4 : 3;
      const columns = Array.from({ length: columnCount }, (_, column) => {
        const indexes = this.tiles.map((_, index) => index).filter((index) => index % columnCount === column);
        for (let next = column + 1; indexes.length < MEDIA_WALL_MIN_TILES_PER_COLUMN; next++) {
          indexes.push(next % this.tiles.length);
        }
        return indexes;
      });

      this.style.setProperty('--media-wall-columns', String(columnCount));
      const visibleTiles = new Set();
      this.track.replaceChildren(
        ...columns.map((indexes, column) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'media-wall__column';
          const inner = document.createElement('div');
          inner.className = 'media-wall__column-inner';
          inner.style.setProperty('--media-wall-duration', `${MEDIA_WALL_COLUMN_DURATIONS[column % MEDIA_WALL_COLUMN_DURATIONS.length]}s`);
          [...indexes, ...indexes].forEach((index, position) => {
            const tile = this.tiles[index].cloneNode(true);
            if (position >= indexes.length || visibleTiles.has(index)) {
              tile.setAttribute('aria-hidden', 'true');
              tile.setAttribute('tabindex', '-1');
              tile.removeAttribute('data-shopify-editor-block');
            } else {
              visibleTiles.add(index);
            }
            inner.append(tile);
          });
          wrapper.append(inner);
          return wrapper;
        })
      );

      this.columnVideos = Array.from(this.track.children, (column) => Array.from(column.querySelectorAll('video[data-src]')));
      this.playingVideos = this.columnVideos.map(() => null);
      this.videoColumns = new Map();
      this.columnVideos.forEach((videos, column) => {
        videos.forEach((video) => {
          this.videoColumns.set(video, column);
          video.addEventListener('timeupdate', () => {
            if (video.currentTime >= MEDIA_WALL_PREVIEW_SECONDS) video.currentTime = 0;
          });
          this.previewObserver.observe(video);
        });
      });
    }

    canPreview() {
      return this.isActive && !this.isPaused && !this.classList.contains('is-held') && !this.reducedMotion.matches && !document.hidden;
    }

    previewSource(video) {
      const source = video.dataset.src;
      if (Number(video.dataset.srcHeight) <= MEDIA_WALL_PREVIEW_HEIGHT || !window.ThemeVideo) return Promise.resolve(source);
      return window.ThemeVideo.previewSource(source);
    }

    onApproach(entries) {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.prepareObserver.disconnect();
      if (this.reducedMotion.matches) return;
      this.track.querySelectorAll('video[data-src]').forEach((video) => this.previewSource(video));
    }

    onPreviewVisibility(entries) {
      const columns = new Set();
      entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
        target.visibleRatio = isIntersecting ? intersectionRatio : 0;
        if (this.videoColumns.has(target)) columns.add(this.videoColumns.get(target));
      });
      columns.forEach((column) => this.updateColumnPreview(column));
    }

    updateColumnPreview(column) {
      const videos = this.columnVideos[column] || [];
      const current = this.playingVideos[column];
      let next = current && current.visibleRatio >= MEDIA_WALL_TILE_VISIBILITY ? current : null;
      if (!next) {
        next = videos.reduce((best, video) => ((video.visibleRatio || 0) > (best?.visibleRatio || 0) ? video : best), null);
        if (next && next.visibleRatio < MEDIA_WALL_TILE_VISIBILITY) next = null;
      }
      this.playingVideos[column] = next;
      videos.forEach((video) => {
        if (video !== next) video.pause();
      });
      if (next) this.startPreview(next);
    }

    async startPreview(video) {
      if (!this.canPreview()) {
        video.pause();
        return;
      }
      if (!video.getAttribute('src')) {
        const generation = this.previewGeneration;
        const source = await this.previewSource(video);
        if (!this.isActive || generation !== this.previewGeneration) return;
        if (!video.getAttribute('src')) video.src = source;
      }
      if (this.canPreview() && this.playingVideos.includes(video)) video.play().catch(() => {});
    }

    pausePreviews() {
      this.track.querySelectorAll('video').forEach((video) => video.pause());
    }

    resumePreviews() {
      (this.columnVideos || []).forEach((_, column) => this.updateColumnPreview(column));
    }

    setPaused(paused) {
      this.isPaused = paused;
      this.classList.toggle('is-paused', paused);
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-label', paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
    }

    onPauseClick() {
      this.setPaused(!this.isPaused);
      if (this.isPaused) this.pausePreviews();
      else this.resumePreviews();
    }

    onVisibilityChange() {
      if (document.hidden) this.pausePreviews();
      else this.resumePreviews();
    }

    onTileClick(event) {
      const tile = event.target.closest('.media-wall__tile[data-wall-clip]');
      if (!tile) return;

      this.lastTile = tile;
      this.playerSeen = false;
      this.classList.add('is-held');
      this.pausePreviews();
      this.player.hidden = false;
      this.openClip(Number(tile.dataset.wallIndex) || 0);

      const frame = this.player.firstElementChild;
      if (!this.reducedMotion.matches) {
        frame.animate([{ opacity: 0, transform: 'scale(0.94)' }, { opacity: 1, transform: 'none' }], {
          duration: 220,
          easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
        });
      }
      this.closeButton.focus({ preventScroll: true });
    }

    openClip(index) {
      const tile = this.clips[index];
      if (!tile) return;

      this.clipIndex = index;
      this.playerVideo.poster = tile.dataset.wallPoster || '';
      this.playerVideo.src = tile.dataset.wallClip;
      if (this.playerCreator) {
        this.playerCreator.textContent = tile.dataset.wallCreator || '';
        this.playerCreator.hidden = !tile.dataset.wallCreator;
      }
      this.playerVideo.muted = false;
      this.playerVideo.currentTime = 0;
      this.playerVideo.play().catch(() => {});

      if (this.counter) this.counter.textContent = `${index + 1} / ${this.clips.length}`;
      if (this.prevStep) this.prevStep.disabled = index === 0;
      if (this.nextStep) this.nextStep.disabled = index === this.clips.length - 1;
    }

    step(offset) {
      this.openClip(this.clipIndex + offset);
      const active = document.activeElement;
      if (this.player.contains(active) && !active.disabled) return;
      const fallback = [this.prevStep, this.nextStep].find((button) => button && !button.disabled) || this.closeButton;
      fallback.focus({ preventScroll: true });
    }

    onPlayerClick(event) {
      const stepButton = event.target.closest('[data-wall-step]');
      if (stepButton) {
        this.step(Number(stepButton.dataset.wallStep));
      } else if (event.target.closest('.media-wall__close') || event.target === this.player) {
        this.close();
      } else if (event.target.closest('.media-wall__toggle')) {
        if (this.playerVideo.paused) this.playerVideo.play().catch(() => {});
        else this.playerVideo.pause();
      }
    }

    onPlayerVisibility({ isIntersecting }) {
      if (isIntersecting) {
        this.playerSeen = true;
      } else if (this.playerSeen) {
        this.playerSeen = false;
        this.close();
      }
    }

    onPlayState() {
      const label = this.playerVideo.paused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel;
      this.toggleButton.setAttribute('aria-label', label);
    }

    onKeydown(event) {
      if (this.player.hidden) return;
      if (event.key === 'Escape') {
        this.close();
      } else if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') && this.clips.length > 1) {
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Tab') {
        event.preventDefault();
        const controls = Array.from(this.player.querySelectorAll('button:not(:disabled)'));
        const current = controls.indexOf(document.activeElement);
        const next = current === -1 ? 0 : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[next]?.focus();
      }
    }

    close() {
      if (this.player.hidden) return;
      this.playerVideo.pause();
      this.player.hidden = true;
      this.playerVideo.removeAttribute('src');
      this.playerVideo.load();
      this.classList.remove('is-held');
      this.resumePreviews();
      this.lastTile?.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('media-wall')) customElements.define('media-wall', MediaWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-hero-slider')) {
    class StoryHeroSlider extends HTMLElement {
      connectedCallback() {
        this.onStaticClick = this.onStaticClick.bind(this);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.stopVideos();
        customElements.whenDefined('flickity-carousel').then(() => this.bindCarousel());
      }

      stopVideos() {
        this.querySelectorAll('video[autoplay]').forEach((video) => {
          video.autoplay = false;
          video.pause();
        });
      }

      disconnectedCallback() {
        if (this.flickity) this.flickity.off('staticClick', this.onStaticClick);
        this.resizeObserver?.disconnect();
        clearTimeout(this.resizeTimer);
        this.flickity = null;
      }

      async bindCarousel() {
        const carousel = this.querySelector('flickity-carousel');
        if (!carousel) return;
        if (!carousel.flickityInstance) {
          await new Promise((resolve) => carousel.addEventListener('flickity:ready', resolve, { once: true }));
        }
        const flickity = await carousel.flickityInstance;
        if (!flickity || !this.isConnected) return;
        carousel.removeAttribute('tabindex');
        this.flickity = flickity;
        flickity.on('staticClick', this.onStaticClick);
        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.resizeCarousel(), 100);
        });
        this.resizeObserver.observe(this);
      }

      resizeCarousel() {
        const flickity = this.flickity;
        if (!flickity || this.resizePending) return;
        if (flickity.isAnimating) {
          this.resizePending = true;
          flickity.once('settle', () => {
            this.resizePending = false;
            this.resizeCarousel();
          });
          return;
        }
        flickity.resize();
      }

      onStaticClick(event, pointer) {
        if (!pointer || window.matchMedia('(min-width: 1000px)').matches) return;
        const bounds = this.getBoundingClientRect();
        const position = (pointer.clientX - bounds.left) / bounds.width;
        if (position <= 0.38) this.flickity.previous();
        if (position >= 0.62) this.flickity.next();
      }
    }

    customElements.define('story-hero-slider', StoryHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viewer-3d"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('viewer-3d')) {
    const MODEL_TAG = 'viewer-3d-model';
    const PICK_SLOT = 'hotspot-viewer-3d-pick';
    const DEFAULT_NORMAL = '0m 1m 0m';
    const VECTOR_PART = /^-?(\d+\.?\d*|\.\d+)(e[-+]?\d+)?(m|cm|mm)?$/i;
    const LABEL_COLUMN_REACH = 0.35;
    const LABEL_ROW_CENTER = 0.56;
    const LABEL_ROW_STEP = 0.29;
    let libraryRequest = null;

    const loadModelLibrary = (url) => {
      if (customElements.get(MODEL_TAG)) return Promise.resolve();
      if (!libraryRequest) {
        libraryRequest = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = true;
          script.addEventListener('load', () => customElements.whenDefined(MODEL_TAG).then(resolve));
          script.addEventListener('error', () => {
            libraryRequest = null;
            script.remove();
            reject(new Error('viewer-3d: model library failed to load'));
          });
          document.head.appendChild(script);
        });
      }
      return libraryRequest;
    };

    const parseVector = (value) => {
      const parts = (value || '').trim().replace(/,\s+/g, ' ').split(/\s+/);
      return parts.length === 3 && parts.every((part) => VECTOR_PART.test(part)) ? parts.join(' ') : '';
    };

    const formatVector = (vector) => `${vector.x.toFixed(4)}m ${vector.y.toFixed(4)}m ${vector.z.toFixed(4)}m`;

    class Viewer3d extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onModelLoad = this.onModelLoad.bind(this);
        this.onModelError = this.onModelError.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onWideChange = this.onWideChange.bind(this);
        this.advanceTour = this.advanceTour.bind(this);
        this.track = this.track.bind(this);
      }

      connectedCallback() {
        this.stage = this.querySelector('[data-viewer-3d-stage]');
        this.viewport = this.querySelector('[data-viewer-3d-viewport]');
        this.description = this.querySelector('[data-viewer-3d-description]');
        this.link = this.querySelector('[data-viewer-3d-link]');
        this.errorMessage = this.querySelector('[data-viewer-3d-error]');
        this.caption = this.querySelector('[data-viewer-3d-caption]');
        this.captionHotspot = null;
        this.noModelNote = this.querySelector('[data-viewer-3d-no-model]');
        this.rotationLabel = this.querySelector('[data-viewer-3d-rotation-label]');
        this.items = Array.from(this.querySelectorAll('[data-viewer-3d-item]'));
        this.isDesignMode = this.hasAttribute('data-design-mode');
        this.isShowcase = this.hasAttribute('data-showcase');
        this.focus = this.querySelector('[data-viewer-3d-focus]');
        this.focusCard = this.querySelector('[data-viewer-3d-focus-card]');
        this.focusBar = this.querySelector('[data-viewer-3d-focus-bar]');
        this.focusHotspot = null;
        this.tourHotspot = null;
        this.wideQuery = window.matchMedia('(min-width: 1000px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.model = null;
        this.modelLoading = false;
        this.contextLost = false;
        this.pendingItem = null;
        this.switchTimer = null;
        this.activation = null;
        this.hotspots = [];
        this.hotspotOrder = [];
        this.hotspotHome = null;
        this.activeIndex = -1;
        this.pinned = null;
        this.pendingPin = null;
        this.focusPinned = null;
        this.isPicking = false;
        this.isVisible = false;
        this.isPaused = this.reducedMotion.matches;
        this.labelSizes = new WeakMap();
        this.labelColumns = new Map();
        this.labelObserver =
          'ResizeObserver' in window
            ? new ResizeObserver((entries) => {
                entries.forEach(({ target }) =>
                  this.labelSizes.set(target, { width: target.offsetWidth, height: target.offsetHeight })
                );
              })
            : null;

        this.addEventListener('click', this.onClick);
        this.wideQuery.addEventListener('change', this.onWideChange);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (!this.stage || !this.items.length) return;
        this.updateRotationButton();
        const startIndex = this.items.findIndex((item) => item.dataset.src && item.hasAttribute('data-viewer-3d-start'));
        if (startIndex >= 0) {
          this.select(startIndex);
        } else {
          this.select(Math.max(0, this.items.findIndex((item) => item.dataset.src)), false);
        }
        if (this.items.some((item) => item.dataset.src)) this.observe();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.wideQuery.removeEventListener('change', this.onWideChange);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.loadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.labelObserver?.disconnect();
        this.stopTracking();
        cancelAnimationFrame(this.homeFrame);
        clearTimeout(this.pinTimer);
        clearTimeout(this.tourTimer);
        clearTimeout(this.switchTimer);
        this.switchTimer = null;
        this.pendingItem = null;
        this.returnHotspots();
        if (this.model) {
          this.model.removeEventListener('load', this.onModelLoad);
          this.model.removeEventListener('error', this.onModelError);
          this.model.removeEventListener('pointerdown', this.onPointerDown);
          this.model.removeEventListener('wheel', this.onWheel, { capture: true });
          this.model.remove();
          this.model = null;
        }
        this.pickMarker = null;
        this.activation = null;
        this.stage?.classList.remove('is-loading', 'is-loaded', 'is-empty', 'is-picking');
      }

      observe() {
        if (!('IntersectionObserver' in window)) {
          this.isVisible = true;
          this.activate();
          return;
        }
        this.loadObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.loadObserver.disconnect();
            this.activate();
          },
          { rootMargin: '400px 0px' }
        );
        this.loadObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.isVisible = entries[entries.length - 1].isIntersecting;
          if (this.isVisible) {
            this.startTracking();
          } else {
            this.stopTracking();
          }
        });
        this.visibilityObserver.observe(this.stage);
      }

      activate() {
        if (this.activation) return;
        this.stage.classList.add('is-loading');
        this.activation = loadModelLibrary(this.dataset.libraryUrl)
          .then(() => {
            if (!this.isConnected || this.model) return;
            this.createModel();
            this.showItem(this.items[this.activeIndex]);
          })
          .catch(() => {
            this.stage.classList.remove('is-loading');
            this.setError(true);
          });
      }

      createModel() {
        customElements.get(MODEL_TAG).modelCacheSize = 0;
        const model = document.createElement(MODEL_TAG);
        const attributes = {
          'camera-controls': '',
          'touch-action': 'pan-y',
          'interaction-prompt': 'none',
          'disable-pan': '',
          'disable-tap': '',
          'shadow-intensity': '1',
          'shadow-softness': '0.9',
          'environment-image': 'neutral',
          'min-camera-orbit': 'auto 35deg auto',
          'max-camera-orbit': 'auto 130deg auto',
          'rotation-per-second': '20deg',
          'auto-rotate-delay': '3000',
          loading: 'eager',
        };
        Object.entries(attributes).forEach(([name, value]) => model.setAttribute(name, value));
        if (this.dataset.a11y) model.setAttribute('a11y', this.dataset.a11y);
        model.className = 'viewer-3d__model';

        const progressBar = document.createElement('span');
        progressBar.slot = 'progress-bar';
        model.appendChild(progressBar);

        model.addEventListener('load', this.onModelLoad);
        model.addEventListener('error', this.onModelError);
        model.addEventListener('pointerdown', this.onPointerDown);
        model.addEventListener('wheel', this.onWheel, { capture: true, passive: true });
        this.viewport.appendChild(model);
        this.model = model;
        this.setRotation(true);
      }

      select(index, announce = true) {
        const item = this.items[index];
        if (!item) return;
        const changed = index !== this.activeIndex;
        this.activeIndex = index;
        this.pendingPin = null;

        this.items.forEach((entry, entryIndex) => {
          entry.querySelector('[data-viewer-3d-select]')?.setAttribute('aria-pressed', String(entryIndex === index));
        });

        if (announce && changed) {
          const description = item.querySelector('[data-viewer-3d-item-description]');
          if (this.description) this.description.innerHTML = description ? description.innerHTML : '';
          if (this.link) {
            const href = item.dataset.link;
            this.link.hidden = !href;
            if (href) this.link.href = href;
          }
        }

        this.unpin();
        this.toggleNoModelNote(!item.dataset.src);
        if (this.model && (changed || !this.model.getAttribute('src'))) this.queueItem(item);
      }

      queueItem(item) {
        if (this.contextLost) return;
        this.pendingItem = item;
        clearTimeout(this.switchTimer);
        this.stopTracking();
        clearTimeout(this.tourTimer);
        this.stage.classList.add('is-loading');
        this.stage.classList.remove('is-loaded');
        this.switchTimer = setTimeout(() => {
          this.switchTimer = null;
          this.flushItem();
        }, 150);
      }

      flushItem() {
        if (this.modelLoading || this.contextLost || this.switchTimer || !this.pendingItem || !this.isConnected) return;
        const item = this.pendingItem;
        this.pendingItem = null;
        this.showItem(item);
      }

      showItem(item) {
        const model = this.model;
        if (!model || !item) return;
        this.stopTracking();
        cancelAnimationFrame(this.homeFrame);
        clearTimeout(this.tourTimer);
        this.returnHotspots();
        this.setError(false);

        const src = item.dataset.src;
        model.setAttribute('alt', item.dataset.alt || '');
        model.setAttribute('camera-orbit', this.orbitFor(item));
        model.setAttribute('camera-target', 'auto auto auto');
        model.setAttribute('field-of-view', 'auto');
        if (item.dataset.poster) {
          model.setAttribute('poster', item.dataset.poster);
        } else {
          model.removeAttribute('poster');
        }

        this.stage.classList.toggle('is-empty', !src);
        if (!src) {
          model.removeAttribute('src');
          this.stage.classList.remove('is-loading', 'is-loaded');
          return;
        }

        this.mountHotspots(item);
        if (model.getAttribute('src') === src && model.loaded) {
          this.onModelLoad();
          return;
        }
        this.stage.classList.add('is-loading');
        this.stage.classList.remove('is-loaded');
        this.modelLoading = true;
        model.setAttribute('src', src);
      }

      orbitFor(item) {
        const orbit = item?.dataset.orbit || '-30deg 75deg auto';
        if (!this.dataset.orbitPhi) return orbit;
        return `${orbit.split(' ')[0]} ${this.dataset.orbitPhi} auto`;
      }

      mountHotspots(item) {
        this.hotspotHome = item.querySelector('[data-viewer-3d-item-hotspots]');
        if (!this.hotspotHome) return;
        this.hotspotOrder = Array.from(this.hotspotHome.children);
        const candidates = Array.from(this.hotspotHome.querySelectorAll('[data-viewer-3d-hotspot]'));
        this.hotspots = candidates.filter((hotspot) => parseVector(hotspot.dataset.position) !== '');
        this.hotspots.forEach((hotspot) => {
          hotspot.dataset.position = parseVector(hotspot.dataset.position);
          hotspot.dataset.normal = parseVector(hotspot.dataset.normal) || DEFAULT_NORMAL;
          hotspot.dataset.positionBack = parseVector(hotspot.dataset.positionBack);
          hotspot.dataset.normalBack = parseVector(hotspot.dataset.normalBack) || DEFAULT_NORMAL;
          hotspot.removeAttribute('data-face');
          this.model.appendChild(hotspot);
        });
        this.tourHotspot = this.hotspots[0] || null;
        if (this.isDesignMode && this.hotspots.length < candidates.length) {
          const warning = item.querySelector('[data-viewer-3d-item-warning]');
          if (warning) warning.hidden = false;
        }
        this.applyPendingPin();
      }

      returnHotspots() {
        if (!this.hotspotHome) return;
        this.hotspots.forEach((hotspot) => {
          hotspot.classList.remove('is-active');
          hotspot.removeAttribute('data-side');
          hotspot.removeAttribute('tabindex');
        });
        this.hotspotOrder.forEach((child) => this.hotspotHome.appendChild(child));
        this.labelColumns.clear();
        this.setCaption(null);
        this.updateFocus(null);
        this.hotspots = [];
        this.hotspotOrder = [];
        this.hotspotHome = null;
        this.tourHotspot = null;
      }

      onModelLoad(event) {
        const src = this.model?.getAttribute('src');
        if (event && event.currentTarget !== this.model) return;
        if (!src || this.contextLost || (event?.detail?.url && event.detail.url !== src)) return;
        this.modelLoading = false;
        if (this.pendingItem) {
          this.flushItem();
          return;
        }
        this.setError(false);
        this.stage.classList.remove('is-loading', 'is-empty');
        this.stage.classList.add('is-loaded');
        this.model.resetTurntableRotation(0);
        this.model.jumpCameraToGoal();
        this.labelColumns.clear();
        this.applyPendingPin();
        this.startTracking();
        this.setRotation(true);
        if (this.isTouring() && this.tourHotspot && !this.pinned) this.faceHotspot(this.tourHotspot);
        this.scheduleTour();
      }

      isTouring() {
        return this.isShowcase && !this.wideQuery.matches;
      }

      scheduleTour(delay = 5000) {
        clearTimeout(this.tourTimer);
        if (this.isTouring()) this.tourTimer = setTimeout(this.advanceTour, delay);
        this.runProgress(delay);
      }

      runProgress(delay = 5000) {
        if (!this.focusBar) return;
        const running =
          this.isTouring() &&
          this.hotspots.length > 1 &&
          Boolean(this.model?.loaded) &&
          !this.isPaused &&
          !this.pinned &&
          !this.isPicking;
        this.focusBar.classList.remove('is-running');
        if (!running) return;
        this.focusBar.style.setProperty('--focus-duration', `${Math.max(delay - 300, 0)}ms`);
        void this.focusBar.offsetWidth;
        this.focusBar.classList.add('is-running');
      }

      advanceTour() {
        const total = this.hotspots.length;
        if (total && this.model?.loaded && this.isVisible && !this.isPaused && !this.pinned && !this.isPicking) {
          const current = this.hotspots.indexOf(this.tourHotspot);
          this.tourHotspot = this.hotspots[(current + 1) % total];
          this.faceHotspot(this.tourHotspot);
          this.updateHotspots();
        }
        this.scheduleTour();
      }

      onWideChange() {
        this.setRotation(true);
        this.scheduleTour();
      }

      async onModelError(event) {
        const model = this.model;
        if (event && event.currentTarget !== model) return;
        if (!model?.getAttribute('src')) return;
        this.stopTracking();
        clearTimeout(this.tourTimer);
        cancelAnimationFrame(this.homeFrame);
        if (event?.detail?.type === 'webglcontextlost') {
          this.contextLost = true;
          clearTimeout(this.switchTimer);
          this.switchTimer = null;
          this.pendingItem = null;
          model.autoRotate = false;
        }
        this.stage.classList.remove('is-loading', 'is-loaded');
        this.stage.classList.add('is-empty');
        this.setError(true);
        model.removeAttribute('src');
        await model.updateComplete;
        if (!this.isConnected || this.model !== model) return;
        this.modelLoading = false;
        this.flushItem();
      }

      setError(visible) {
        if (this.errorMessage) this.errorMessage.hidden = !visible;
      }

      toggleNoModelNote(visible) {
        if (this.noModelNote) this.noModelNote.hidden = !visible;
      }

      startTracking() {
        if (this.trackingFrame || !this.isVisible || !this.model?.loaded || this.modelLoading || this.contextLost) return;
        this.trackingFrame = requestAnimationFrame(this.track);
      }

      stopTracking() {
        cancelAnimationFrame(this.trackingFrame);
        this.trackingFrame = null;
      }

      track() {
        this.trackingFrame = requestAnimationFrame(this.track);
        this.updateHotspots();
      }

      updateHotspots() {
        const model = this.model;
        if (!model || !this.hotspots.length || !model.loaded) return;

        const width = model.clientWidth;
        const height = model.clientHeight;
        const wide = this.isShowcase && this.wideQuery.matches;
        if (wide && !this.labelColumns.size) this.planLabels();
        const orbit = model.getCameraOrbit();
        const yaw = model.turntableRotation || 0;
        const view = {
          x: Math.sin(orbit.phi) * Math.sin(orbit.theta),
          y: Math.cos(orbit.phi),
          z: Math.sin(orbit.phi) * Math.cos(orbit.theta),
        };

        const readings = this.hotspots.map((hotspot) => {
          const { width: labelWidth, height: labelHeight } = this.labelSize(hotspot);
          return { hotspot, data: model.queryHotspot(hotspot.slot), labelWidth, labelHeight };
        });

        this.hotspots.forEach((hotspot) => this.updateFace(hotspot, yaw, view));

        let featured = null;
        let bestScore = 0.35;
        const updates = [];

        readings.forEach(({ hotspot, data, labelWidth, labelHeight }) => {
          if (!data) return;
          const x = data.canvasPosition.x;
          let side = 'right';
          if (wide) {
            side = this.labelColumns.get(hotspot)?.side || side;
          } else {
            side = hotspot.dataset.side || (x > width / 2 ? 'left' : 'right');
            if (side === 'right' && x > width * 0.58) side = 'left';
            if (side === 'left' && x < width * 0.42) side = 'right';
            const reach = labelWidth + 28;
            if (side === 'right' && x + reach > width - 8 && x - reach > 8) side = 'left';
            if (side === 'left' && x - reach < 8 && x + reach < width - 8) side = 'right';
          }
          updates.push({ hotspot, side, labelWidth, labelHeight, facing: data.facingCamera, position: data.canvasPosition });

          if (!data.facingCamera) return;
          const normal = data.normal;
          const length = Math.hypot(normal.x, normal.y, normal.z) || 1;
          const worldX = (normal.x * Math.cos(yaw) + normal.z * Math.sin(yaw)) / length;
          const worldZ = (normal.z * Math.cos(yaw) - normal.x * Math.sin(yaw)) / length;
          const score =
            worldX * view.x + (normal.y / length) * view.y + worldZ * view.z + (hotspot === this.featured ? 0.08 : 0);
          if (score > bestScore) {
            bestScore = score;
            featured = hotspot;
          }
        });

        this.featured = featured;
        let active = this.pinned || (this.isTouring() ? this.tourHotspot : featured);
        if (this.isShowcase && !this.hotspots.includes(active)) {
          active = this.hotspots.includes(this.focusHotspot) ? this.focusHotspot : this.hotspots[0];
        }
        updates.forEach(({ hotspot, side, labelWidth, labelHeight, facing, position }) => {
          if (hotspot.dataset.side !== side) hotspot.dataset.side = side;
          if (wide && this.labelColumns.has(hotspot)) {
            const slot = this.labelSlot(hotspot, labelWidth, labelHeight, width, height);
            const reach = slot.x - position.x;
            const offset = slot.y - position.y;
            const left = side === 'right' ? slot.x : slot.x - labelWidth;
            const top = Math.round(slot.y - labelHeight / 2);
            const values = {
              '--viewer-3d-label-x': `${(left - position.x).toFixed(3)}px`,
              '--viewer-3d-label-y': `${(top - position.y).toFixed(3)}px`,
              '--viewer-3d-length': `${Math.hypot(reach, offset).toFixed(2)}px`,
              '--viewer-3d-angle': `${Math.atan2(offset, reach).toFixed(3)}rad`,
            };
            Object.entries(values).forEach(([name, value]) => {
              if (hotspot.style.getPropertyValue(name) !== value) hotspot.style.setProperty(name, value);
            });
          }
          const focusable = facing || hotspot === this.pinned;
          if (!focusable && hotspot.getAttribute('tabindex') !== '-1') {
            hotspot.setAttribute('tabindex', '-1');
          } else if (focusable && hotspot.hasAttribute('tabindex')) {
            hotspot.removeAttribute('tabindex');
          }
        });
        this.hotspots.forEach((hotspot) => hotspot.classList.toggle('is-active', hotspot === active));
        this.setCaption(active);
        if (this.isShowcase) this.updateFocus(active, updates);
      }

      labelSize(hotspot) {
        const label = hotspot.querySelector('[data-viewer-3d-hotspot-label]');
        if (!label) return { width: 0, height: 0 };
        if (!this.labelObserver) return { width: label.offsetWidth, height: label.offsetHeight };
        if (!this.labelSizes.has(label)) {
          this.labelSizes.set(label, { width: label.offsetWidth, height: label.offsetHeight });
          this.labelObserver.observe(label);
        }
        return this.labelSizes.get(label);
      }

      planLabels() {
        const theta = (parseFloat(this.orbitFor(this.items[this.activeIndex])) * Math.PI) / 180;
        const center = this.model.getBoundingBoxCenter();
        const columns = { left: [], right: [] };
        this.hotspots.forEach((hotspot) => {
          const [x, y, z] = hotspot.dataset.position.split(' ').map(parseFloat);
          const across = (x - center.x) * Math.cos(theta) - (z - center.z) * Math.sin(theta);
          columns[across < 0 ? 'left' : 'right'].push({ hotspot, height: y });
        });
        Object.entries(columns).forEach(([side, column]) => {
          column.sort((a, b) => b.height - a.height);
          column.forEach(({ hotspot }, index) => this.labelColumns.set(hotspot, { side, index, count: column.length }));
        });
      }

      labelSlot(hotspot, labelWidth, labelHeight, width, height) {
        const { side, index, count } = this.labelColumns.get(hotspot);
        const reach = height * LABEL_COLUMN_REACH;
        const x =
          side === 'left' ? Math.max(width / 2 - reach, labelWidth + 24) : Math.min(width / 2 + reach, width - labelWidth - 16);
        const step = count > 1 ? Math.min(height * LABEL_ROW_STEP, (height - labelHeight - 32) / (count - 1)) : 0;
        const edge = labelHeight / 2 + 16;
        const y = Math.min(Math.max(height * LABEL_ROW_CENTER + (index - (count - 1) / 2) * step, edge), height - edge);
        return { x: Math.round(x), y: Math.round(y) };
      }

      updateFace(hotspot, yaw, view) {
        const back = hotspot.dataset.positionBack;
        if (!back) return;
        const score = (value) => {
          const [x, y, z] = value.split(' ').map(parseFloat);
          const length = Math.hypot(x, y, z) || 1;
          const worldX = (x * Math.cos(yaw) + z * Math.sin(yaw)) / length;
          const worldZ = (z * Math.cos(yaw) - x * Math.sin(yaw)) / length;
          return worldX * view.x + (y / length) * view.y + worldZ * view.z;
        };
        const lead = score(hotspot.dataset.normal) - score(hotspot.dataset.normalBack);
        const current = hotspot.dataset.face || 'front';
        const face = current === 'front' ? (lead < -0.1 ? 'back' : 'front') : lead > 0.1 ? 'front' : 'back';
        if (face === current) return;
        hotspot.dataset.face = face;
        this.model.updateHotspot({
          name: hotspot.slot,
          position: face === 'back' ? back : hotspot.dataset.position,
          normal: face === 'back' ? hotspot.dataset.normalBack : hotspot.dataset.normal,
        });
      }

      updateFocus(hotspot, updates = []) {
        if (!this.focus) return;
        this.stage.classList.toggle('has-focus', Boolean(hotspot));
        if (!hotspot) {
          this.focusHotspot = null;
          this.stage.classList.remove('has-focus-line');
          return;
        }
        if (hotspot !== this.focusHotspot) {
          this.focusHotspot = hotspot;
          const index = this.hotspots.indexOf(hotspot) + 1;
          const total = this.hotspots.length;
          const pad = (value) => String(value).padStart(2, '0');
          const media = hotspot.querySelector('[data-viewer-3d-hotspot-media]');
          this.focus.querySelector('[data-viewer-3d-focus-count]').textContent = `${pad(index)} / ${pad(total)}`;
          this.focus.querySelector('[data-viewer-3d-focus-title]').textContent =
            hotspot.querySelector('[data-viewer-3d-hotspot-title]')?.textContent.trim() || '';
          this.focus.querySelector('[data-viewer-3d-focus-text]').textContent =
            hotspot.querySelector('[data-viewer-3d-hotspot-text]')?.textContent.trim() || '';
          this.focus.querySelector('[data-viewer-3d-focus-media]').innerHTML = media ? media.innerHTML : '';
        }
        const reading = updates.find((entry) => entry.hotspot === hotspot);
        const cardTop = this.focusCard ? this.focusCard.offsetTop : 0;
        const start = reading ? reading.position.y + 14 : 0;
        const visible = Boolean(reading && reading.facing) && cardTop - start > 8;
        this.stage.classList.toggle('has-focus-line', visible);
        if (!visible) return;
        this.focus.style.setProperty('--focus-x', `${reading.position.x.toFixed(2)}px`);
        this.focus.style.setProperty('--focus-y', `${start.toFixed(2)}px`);
        this.focus.style.setProperty('--focus-length', `${(cardTop - start).toFixed(2)}px`);
      }

      step(direction) {
        const total = this.hotspots.length;
        if (!total) return;
        const current = this.hotspots.indexOf(this.pinned || this.focusHotspot);
        const hotspot = this.hotspots[current < 0 ? 0 : (current + direction + total) % total];
        this.pin(hotspot);
        this.faceHotspot(hotspot);
      }

      faceHotspot(hotspot) {
        const model = this.model;
        const data = model?.loaded ? model.queryHotspot(hotspot.slot) : null;
        if (!data) return;
        const normal = data.normal;
        const length = Math.hypot(normal.x, normal.y, normal.z) || 1;
        const yaw = model.turntableRotation || 0;
        const worldX = (normal.x * Math.cos(yaw) + normal.z * Math.sin(yaw)) / length;
        const worldZ = (normal.z * Math.cos(yaw) - normal.x * Math.sin(yaw)) / length;
        const orbit = model.getCameraOrbit();
        const start = (parseFloat(this.orbitFor(this.items[this.activeIndex])) * Math.PI) / 180 + yaw;
        const theta = Math.hypot(worldX, worldZ) > 0.2 ? Math.atan2(worldX, worldZ) : start;
        const phi = Math.min(Math.max(Math.acos(normal.y / length), 0.87), 2.27);
        model.cameraOrbit = `${theta}rad ${phi}rad ${orbit.radius}m`;
      }

      setCaption(hotspot) {
        if (!this.caption || hotspot === this.captionHotspot) return;
        this.captionHotspot = hotspot;
        const text = hotspot?.querySelector('[data-viewer-3d-hotspot-text]')?.textContent.trim() || '';
        if (text) this.caption.textContent = text;
        this.stage.classList.toggle('has-caption', text !== '');
      }

      pin(hotspot, { timed = !this.isDesignMode } = {}) {
        this.pinned = hotspot;
        if (this.isTouring()) this.tourHotspot = hotspot;
        this.setRotation(false);
        clearTimeout(this.pinTimer);
        if (timed) this.pinTimer = setTimeout(() => this.unpin(), 8000);
        this.runProgress();
        this.updateHotspots();
      }

      unpin() {
        if (!this.pinned) return;
        this.pinned = null;
        clearTimeout(this.pinTimer);
        this.setRotation(true);
        this.scheduleTour();
        this.updateHotspots();
      }

      applyPendingPin() {
        const hotspot = this.pendingPin;
        if (!hotspot || !this.hotspots.includes(hotspot)) return;
        this.pendingPin = null;
        this.pin(hotspot, { timed: false });
      }

      setRotation(enabled) {
        if (!this.model) return;
        this.model.autoRotate = enabled && !this.isPaused && !this.isPicking && !this.pinned && !this.isTouring();
      }

      toggleRotation() {
        this.isPaused = !this.isPaused;
        this.updateRotationButton();
        this.setRotation(true);
        this.scheduleTour();
      }

      updateRotationButton() {
        this.stage?.classList.toggle('is-paused', this.isPaused);
        if (this.rotationLabel) {
          this.rotationLabel.textContent = this.isPaused ? this.dataset.labelPlay : this.dataset.labelPause;
        }
      }

      resetView() {
        if (!this.model) return;
        const item = this.items[this.activeIndex];
        this.unpin();
        this.tourHotspot = this.hotspots[0] || null;
        this.scheduleTour();
        this.model.cameraOrbit = this.orbitFor(item);
        this.model.cameraTarget = 'auto auto auto';
        this.model.fieldOfView = 'auto';
        this.rotateHome();
      }

      rotateHome() {
        const model = this.model;
        const fullTurn = Math.PI * 2;
        const start = (((model.turntableRotation % fullTurn) + fullTurn + Math.PI) % fullTurn) - Math.PI;
        cancelAnimationFrame(this.homeFrame);
        if (this.reducedMotion.matches || Math.abs(start) < 0.001) {
          model.resetTurntableRotation(0);
          return;
        }
        model.autoRotate = false;
        const begin = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - begin) / 600);
          const eased = 1 - Math.pow(1 - progress, 3);
          model.resetTurntableRotation(start * (1 - eased));
          if (progress < 1) {
            this.homeFrame = requestAnimationFrame(step);
          } else {
            this.setRotation(true);
          }
        };
        this.homeFrame = requestAnimationFrame(step);
      }

      onClick(event) {
        const selectButton = event.target.closest('[data-viewer-3d-select]');
        if (selectButton) {
          this.select(this.items.indexOf(selectButton.closest('[data-viewer-3d-item]')));
          return;
        }
        const stepButton = event.target.closest('[data-viewer-3d-step]');
        if (stepButton) {
          this.step(Number(stepButton.getAttribute('data-viewer-3d-step')));
          return;
        }
        if (event.target.closest('[data-viewer-3d-reset]')) {
          this.resetView();
          return;
        }
        if (event.target.closest('[data-viewer-3d-rotation]')) {
          this.toggleRotation();
          return;
        }
        if (event.target.closest('[data-viewer-3d-pick]')) {
          this.togglePicker();
          return;
        }
        const hotspot = event.target.closest('[data-viewer-3d-hotspot]');
        if (hotspot) {
          if (this.pinned === hotspot && !this.isDesignMode) {
            this.unpin();
          } else {
            this.pin(hotspot);
          }
          return;
        }
        if (this.model && event.target === this.model) this.onModelClick(event);
      }

      onPointerDown(event) {
        this.pointerStart = { x: event.clientX, y: event.clientY };
        if (this.isTouring()) this.scheduleTour(8000);
      }

      onModelClick(event) {
        const start = this.pointerStart;
        if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 6) return;
        if (this.isPicking) {
          this.pickPoint(event.clientX, event.clientY);
          return;
        }
        this.unpin();
      }

      onWheel(event) {
        if (!event.ctrlKey && !event.metaKey) event.stopPropagation();
      }

      onFocusIn(event) {
        if (event.target.matches('[data-viewer-3d-pick-position], [data-viewer-3d-pick-normal]')) {
          event.target.select();
          return;
        }
        const hotspot = event.target.closest('[data-viewer-3d-hotspot]');
        if (hotspot && this.hotspots.includes(hotspot) && hotspot.matches(':focus-visible')) {
          this.focusPinned = hotspot;
          this.pin(hotspot, { timed: false });
        }
      }

      onFocusOut(event) {
        const hotspot = event.target.closest('[data-viewer-3d-hotspot]');
        if (!hotspot || hotspot !== this.focusPinned) return;
        this.focusPinned = null;
        if (hotspot === this.pinned && !this.isDesignMode) this.unpin();
      }

      togglePicker() {
        this.isPicking = !this.isPicking;
        this.querySelector('[data-viewer-3d-pick]')?.setAttribute('aria-pressed', String(this.isPicking));
        const panel = this.querySelector('[data-viewer-3d-pick-panel]');
        if (panel) panel.hidden = !this.isPicking;
        this.stage.classList.toggle('is-picking', this.isPicking);
        this.setRotation(true);
        this.scheduleTour();
      }

      pickPoint(x, y) {
        const hit = this.model?.positionAndNormalFromPoint(x, y);
        if (!hit) return;
        const position = formatVector(hit.position);
        const normal = formatVector(hit.normal);
        const positionField = this.querySelector('[data-viewer-3d-pick-position]');
        const normalField = this.querySelector('[data-viewer-3d-pick-normal]');
        if (positionField) positionField.value = position;
        if (normalField) normalField.value = normal;

        if (this.pickMarker && this.pickMarker.parentNode === this.model) {
          this.model.updateHotspot({ name: PICK_SLOT, position, normal });
          return;
        }
        this.pickMarker = document.createElement('span');
        this.pickMarker.className = 'viewer-3d__pick-marker';
        this.pickMarker.slot = PICK_SLOT;
        this.pickMarker.dataset.position = position;
        this.pickMarker.dataset.normal = normal;
        this.model.appendChild(this.pickMarker);
      }

      onBlockSelect(event) {
        const hotspot = event.target.closest('[data-viewer-3d-hotspot]');
        const item = event.target.closest('[data-viewer-3d-item]');
        if (hotspot) {
          const ownerIndex = item ? this.items.indexOf(item) : this.activeIndex;
          this.select(ownerIndex);
          if (parseVector(hotspot.dataset.position)) {
            this.pendingPin = hotspot;
            this.applyPendingPin();
          } else if (!this.isPicking && this.querySelector('[data-viewer-3d-pick]')) {
            this.togglePicker();
          }
          return;
        }
        if (item) this.select(this.items.indexOf(item));
      }

      onBlockDeselect() {
        this.pendingPin = null;
        this.unpin();
      }
    }

    customElements.define('viewer-3d', Viewer3d);
  }

  } catch(e) { console.error(e); }
})();
})();
